// Pages/AdminSetup/AdminSetup.jsx
import { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import "../Styles/Admin-Users.css"

export default function AdminSetup({ apiBase }) {
  const { search } = useLocation();
  const token = useMemo(() => new URLSearchParams(search).get("token") || "", [search]);

  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  async function submit(e) {
    e.preventDefault();
    setErr(""); setMsg("");

    const res = await fetch(`/api/admin/users/set-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, password }),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) return setErr(data.error || "Failed");

    setMsg("Password set! You can now go to the admin login page.");
    setPassword("");
  }

  return (
    <section className="admin-setup-card">
      <h2>Set Admin Password</h2>
      <p className="muted small">
        This will only work after your invite has been approved.
      </p>

      <form onSubmit={submit} className="admin-form-grid">
        <label>
          <span>New password</span>
          <input
            type="password"
            placeholder="Min 10 characters"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>

        <div className="admin-actions">
          <button className="btn primary" type="submit">Set Password</button>
        </div>

        {err && <p className="status-line error">{err}</p>}
        {msg && <p className="status-line success">{msg}</p>}
      </form>
    </section>
  );
}
